import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import countries from '../../Torneio/countries';

const PlayerFormDialog = ({ open, onClose, player, onSave }) => {
  const [formData, setFormData] = useState({});

  useEffect(() => {
    setFormData(player || {});
  }, [player, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{player ? 'Editar jogador' : 'Adicionar jogador'}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ pt: 1 }}>
          <Grid item xs={12} sm={8}><TextField label="Nome" name="nome" value={formData.nome || ''} onChange={handleChange} fullWidth /></Grid>
          <Grid item xs={12} sm={4}><TextField label="Código de votação" name="codigoVotacao" value={formData.codigoVotacao || ''} onChange={handleChange} fullWidth /></Grid>
          <Grid item xs={6} sm={4}><TextField label="Número" type="number" name="numeroCamisa" value={formData.numeroCamisa || ''} onChange={handleChange} fullWidth /></Grid>
          <Grid item xs={6} sm={4}>
            <TextField select label="Tamanho" name="tamanhoCamisa" value={formData.tamanhoCamisa || ''} onChange={handleChange} fullWidth>
              {['P', 'M', 'G', 'GG'].map((t) => <MenuItem key={t} value={t}>{t}</MenuItem>)}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              options={countries}
              getOptionLabel={(option) => option.label}
              value={countries.find((option) => option.value === formData.pais) || null}
              onChange={(e, option) => setFormData({ ...formData, pais: option ? option.value : '' })}
              renderInput={(params) => <TextField {...params} label="País" />}
            />
          </Grid>
          <Grid item xs={12}><TextField label="Nome do convidado" name="nomeConvidado" value={formData.nomeConvidado || ''} onChange={handleChange} fullWidth /></Grid>
          <Grid item xs={6}>
            <TextField select label="Pagou?" name="pago" value={formData.pago || ''} onChange={handleChange} fullWidth>
              <MenuItem value="SIM">Sim</MenuItem>
              <MenuItem value="NÃO">Não</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <TextField select label="Vai à festa?" name="festa" value={formData.festa || ''} onChange={handleChange} fullWidth>
              <MenuItem value="SIM">Sim</MenuItem>
              <MenuItem value="NÃO">Não</MenuItem>
            </TextField>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit">Cancelar</Button>
        <Button onClick={() => onSave(formData)} variant="contained">Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PlayerFormDialog;
